/**
 * Author:hong.rong
 * Desc:常用处理工具
 */

import cloneDeep from 'lodash/cloneDeep'
import isString from 'lodash/isString'

export function arrayToTree(array, id = 'id', parentId = 'pid', children = 'children') {
  const result = []
  const hash = {}
  const data = cloneDeep(array)

  data.forEach((item, index) => {
    hash[data[index][id]] = data[index]
  })

  data.forEach(item => {
    const hashParent = hash[item[parentId]]
    if (hashParent) {
      !hashParent[children] && (hashParent[children] = [])
      hashParent[children].push(item)
    } else {
      result.push(item)
    }
  })
  return result
}

export class UtilHelper {
  /**
   * 阻塞线程
   * @param duration
   * @returns {Promise<unknown>}
   */
  static async sleep(duration: number) {
    return new Promise(resolve => {
      setTimeout(resolve, duration)
    })
  }

  /**
   * 数组转多维
   * @param   {array}     array     The Array need to Converted.
   * @param   {string}    id        The alias of the unique ID of the object in the array.
   * @param   {string}    parentId       The alias of the parent ID of the object in the array.
   * @param   {string}    children  The alias of children of the object in the array.
   * @return  {array}    Return a tree-structured array.
   */
  static arrayToTree(array, id = 'id', parentId = 'pid', children = 'children') {
    const result = []
    const hash = {}
    const data = cloneDeep(array)

    data.forEach((item, index) => {
      hash[data[index][id]] = data[index]
    })

    data.forEach(item => {
      const hashParent = hash[item[parentId]]
      if (hashParent) {
        !hashParent[children] && (hashParent[children] = [])
        hashParent[children].push(item)
      } else {
        result.push(item)
      }
    })
    return result
  }

  /**
   * 删除参数参数中undefined值
   * @param params
   */
  static deleteUndefined(params = {}) {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const property in params) {
      const value =
        typeof params[property] === 'string' ? params[property].trim() : params[property]
      if (!value && value !== 0 && value !== '' && typeof value !== 'boolean') {
        // eslint-disable-next-line no-param-reassign
        delete params[property]
      }
    }
    return params
  }

  /**
   * 计算Table x轴滚动值
   * @returns {*}
   */
  static calcAntdTableScrollX = (columns = []) => {
    if (!Array.isArray(columns)) {
      return 0
    }
    return columns.reduce((preValue, next) => {
      if (next.width) {
        return preValue + next.width
      }
      return preValue
    }, 0)
  }

  /**
   * oss拼接参数工具类
   * @param url
   * @param parameter
   */
  static formatOSSUrl = (url: string, parameter: string) => {
    if (!isString(url) || !isString(parameter) || !url || !parameter) {
      return url
    }
    if (url.includes('?')) {
      return `${url}&${parameter}`
    }
    return `${url}?${parameter}`
  }
}
